export const SkillObj = {
    id : 'skills',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    imgStart: false,
    img1: require('../../images/character-6.svg').default,
    img2: require('../../images/character-13.svg').default,
    tooltipa: 'Writes clean and secure APIs in Python',
    tooltipb: 'Scrapes, cleans, processes and visualizes data | Creates ML predictive models',
    tooltipc: 'Creates, scales, and manages cloud infrastructure on AWS',
    tooltipd: 'Writes and maintains clean codes in GitHub',
    tooltipe: 'Containerizes web application applications using docker',
    tooltipf: 'Deploying application on cloud or Linux servers',
    tooltipg: 'Creates interactive webpages using CSS, HTML, js, and React',
    tooltip1: 'Python | >3 Years | Expert Usage | Can build backend applications from scratch using Django or Flask',
    tooltip2: 'Docker | >2 Years | Moderate Usage | Able to create, deploy and manage application containers',
    tooltip3: 'AWS | >2 Years | Moderate Usage | Posses knowledge of services like ECS, EB, S3, EC2, SQS, RDS, Route53, ColudFront etc.',
    tooltip4: 'React | > 4 Months | Beginner Level | Able to build static websites from scratch',
    tooltip5: 'Linux | > 3 Years | Expert Usage | Can use unix terminals to navigate and run commands, can write bash scripts',
    tooltip6: 'GitHub | > 4 Years | Expert Usage | Posses knowledge of various Git functionalities and features',
    darkText: false
};
